import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import { DefaultDivider } from 'services/UIUtils';

/**@param {any} props*/
const SelectableListItem = ({
  selected,
  onClick,
  item,
  disabled,
  special,
  className = '',
  divider = true,
  style,
  onKeyDown,
  forwardRef,
  id,
}) => {
  if (selected === true) className += ' selected';
  if (special === true) className += ' special';

  return (
    <>
      <ListItem
        disabled={disabled}
        onClick={onClick}
        className={className}
        style={style}
        id={id}
        onKeyDown={onKeyDown}
        button
        ref={forwardRef}
      >
        <div className="truncate">{item}</div>

        {selected ? (
          <div>
            <div className="marker" />
            <div className="border" />
          </div>
        ) : null}
      </ListItem>
      {divider ? <DefaultDivider /> : null}
    </>
  );
};

SelectableListItem.propTypes = {
  item: PropTypes.element.isRequired,
  divider: PropTypes.bool,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  special: PropTypes.bool,
};

export default SelectableListItem;
